import {
  constants,
  mediaQueryStyles,
  typographyStyles,
} from "@newsela/angelou";
const { mediaQuery } = mediaQueryStyles;
const { colors, breakpoints } = constants;
const { heading4Obj } = typographyStyles;

const lightGrey = colors.ui.neutral[100];

export const collapseContainerCss = {
  width: "100%",
  maxWidth: "720px",
  display: "flex",
  flexDirection: "column",
  [mediaQuery.upTo(breakpoints.BreakpointNames.sm)]: {
    display: "none",
  },
};

export const collapseCustomTriggerCss = {
  display: "flex",
  justifyContent: "space-between",
  borderBottom: `solid ${lightGrey} 1px`,
  marginBottom: "26px",
  width: "88%",
  // At small screen sizes, the collapse component header appears more narrow than the transcript.
  // This media query corrects that issue and makes both elements appear the same width.
  [mediaQuery.upTo(breakpoints.BreakpointNames.md)]: {
    width: "100%",
  },
  "> div": {
    // Correctly positions the chevron in the center of the header element.
    display: "flex",
  },
};

export const transcriptLabelWrapper = {
  display: "flex",
};

export const transcriptIconCss = {
  width: "23px",
  marginRight: "5px",
};

export const transcriptLabelCss = {
  fontSize: heading4Obj.fontSize,
};
